function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#79848D",
  d: "M8.94 6.074a1.068 1.068 0 00-1.521 0 1.095 1.095 0 000 1.537l5.38 5.438-5.38 5.438a1.095 1.095 0 000 1.537c.42.424 1.101.424 1.521 0l6.141-6.207c.39-.394.418-1.015.084-1.442l-.084-.094-6.14-6.207z"
});

function SvgBackBlack24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI0IDI1Ij4KICAgIDxwYXRoIGZpbGw9IiM3OTg0OEQiIGQ9Ik04Ljk0IDYuMDc0Yy0uNDItLjQyNC0xLjEwMS0uNDI0LTEuNTIxIDAtLjQyLjQyNC0uNDIgMS4xMTIgMCAxLjUzN2w1LjM4IDUuNDM4LTUuMzggNS40MzhjLS40Mi40MjUtLjQyIDEuMTEyIDAgMS41MzcuNDIuNDI0IDEuMTAxLjQyNCAxLjUyMSAwbDYuMTQxLTYuMjA3Yy4zOS0uMzk0LjQxOC0xLjAxNS4wODQtMS40NDJsLS4wODQtLjA5NC02LjE0LTYuMjA3eiIvPgo8L3N2Zz4K";
export { SvgBackBlack24 as ReactComponent };